export const HEAD_CATEGORY = 'head';
export const TOP_CATEGORY = 'top';
export const BOTTOM_CATEGORY = 'bottom';
export const SHOES_CATEGORY = 'shoes';
export const DRESS_CATEGORY = 'dress';
